<script lang="ts">
	import { width } from '$lib/store';
	import { user } from '$lib/user';
	import BloomLogoMember from '../navbar/BloomLogoMember.svelte';
	import NavbarLogo from '../navbar/NavbarLogo.svelte';

	const footerSections = [
		{
			title: 'connect',
			items: [
				{ text: 'Join Bloom', href: '/join' },
				{ text: 'Find your Local Bloom', href: '/engage/localBlooms' },
				{ text: 'Community Calls', href: '/engage/communityCalls' }
			]
		},
		{
			title: 'learn',
			items: [
				{ text: 'Wiki', href: '/learn/wiki' },
				{
					text: 'Whitepaper',
					href: '/learn/whitepaper',
					external: true
				},
				{
					text: 'Litepaper',
					href: 'https://drive.google.com/file/d/1vy9L6BNJdQTifz9Wf425xjxPkL1T6vQg/view?usp=drive_link',
					external: true
				}
			]
		},
		{
			title: 'the dream',
			items: [
				{ text: 'Vision & Values', href: '/vision' },
				{ text: 'Marketplace', href: '/marketplace', preload: 'hover' }
			]
		},
		{
			title: 'support',
			items: [
				{ text: 'Donate', href: '/donate' },
				{ text: 'Volunteer', href: '/bloomers-without-borders' },
				{ text: 'Contact Us', href: 'mailto: community@bloomnetwork.earth' }
			]
		}
	];
</script>

<svelte:window bind:innerWidth={$width} />

<div class="w-full bg-[#0B2C2A] text-white pt-20 pb-10">
	<div class="h-full w-full max-w-7xl mx-auto px-4">
		<div class="flex xl:hidden mx-auto justify-center scale-75 -mt-10 mb-4">
			<BloomLogoMember />
		</div>
		<div
			class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-4 xl:gap-8 md:ml-10 xl:ml-0"
		>
			<div class="hidden xl:block">
				<NavbarLogo user={$user} />
			</div>
			{#each footerSections as section}
				<div>
					<div class="flex justify-center md:justify-start lg:w-2/3">
						<p
							class="uppercase text-base 2xl:text-lg font-bold tracking-wider text-gray-900 dark:text-gray-100 focus:outline-none pt-4 text-center md:text-left mb-0"
						>
							{section.title}
						</p>
					</div>
					<div class="flex justify-center sm:justify-end xl:justify-center">
						<article class="h-auto w-full text-center md:text-left overflow-hidden">
							<ul class="my-5 text-xs tracking-wide">
								{#each section.items as item}
									<li class="my-3 tracking-wide text-gray-900 dark:text-gray-100">
										<a
											class="text-sm"
											href={item.href}
											data-sveltekit-preload-data={item.preload || 'tap'}
											{...item.external ? { rel: 'noopener noreferrer', target: '_blank' } : {}}
										>
											{item.text}
										</a>
									</li>
								{/each}
							</ul>
						</article>
					</div>
				</div>
			{/each}
		</div>
	</div>
	<div
		class="text-center opacity-75 flex flex-col md:flex-row md:gap-10 mx-auto justify-center items-center mt-10"
	>
		<div>© 2025 Bloom Network</div>
		<div class="md:hidden">
			<br />
		</div>
		<!-- <a href="/privacy">Privacy Policy</a> -->
		<a href="https://drive.google.com/file/d/160Kdsh_vvJQ85J-pAvQ1Ha1cJXrACOzC/view?usp=drive_link"
			>Partner Engagement Policy</a
		>
		<div class="md:hidden">
			<br />
		</div>
		<div class="flex gap-4">
			<a
				class="inline-block mx-auto"
				href={'https://twitter.com/ourbloomnetwork'}
				data-sveltekit-preload-data="tap"
			>
				<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<mask
						id="a"
						style="mask-type:alpha"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="32"
						height="32"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0 16C0 7.177 7.177 0 16 0s16 7.177 16 16-7.177 16-16 16S0 24.823 0 16Zm23.027-3.033c0-.152-.003-.303-.01-.454.445-.322.81-1.074 1.141-1.754.177-.365.345-.709.509-.955 0 0-1.8.196-2.6.355a3.51 3.51 0 0 0-5.981 3.199A9.95 9.95 0 0 1 8.851 9.69a3.509 3.509 0 0 0 1.087 4.685 3.527 3.527 0 0 1-1.59-.44v.047a3.508 3.508 0 0 0 2.815 3.438 3.491 3.491 0 0 1-1.584.062 3.515 3.515 0 0 0 3.277 2.438 7.055 7.055 0 0 1-5.194 1.452 9.936 9.936 0 0 0 5.38 1.579c6.454 0 9.984-5.348 9.984-9.985Z"
							fill="#fff"
						/>
					</mask>
					<g mask="url(#a)">
						<path fill="#fff" d="M0 0h32v32H0z" />
					</g>
				</svg>
			</a>
			<a href="https://www.instagram.com/bloomnetwork" class="text-2xl">
				<svg
					version="1.1"
					id="Capa_1"
					xmlns="http://www.w3.org/2000/svg"
					x="0"
					y="0"
					width="32"
					height="32"
					viewBox="0 0 112.2 112.2"
					style="enable-background:new 0 0 112.2 112.2"
					xml:space="preserve"
					><style>
						.st0 {
							fill: #fff;
						}
					</style><path class="st0" d="M62.1 41.3v-.1s-.1 0 0 .1z" /><path
						class="st0"
						d="M69.4 29.5h-27c-7.3 0-13.2 5.9-13.2 13.2v26.9c0 7.3 5.9 13.2 13.2 13.2h26.9c7.3 0 13.2-5.9 13.2-13.2V42.7c.1-7.3-5.8-13.2-13.1-13.2zM55.9 73.4c-9.5 0-17.2-7.7-17.2-17.2S46.4 39 55.9 39s17.2 7.7 17.2 17.2-7.7 17.2-17.2 17.2zm17.3-30.2c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.8 4.1-4.1 4.1z"
					/><path
						class="st0"
						d="M56.1 0C25.1 0 0 25.1 0 56.1s25.1 56.1 56.1 56.1 56.1-25.1 56.1-56.1S87.1 0 56.1 0zm33.2 69.6c0 11-8.9 19.9-19.9 19.9h-27c-11 0-19.9-8.9-19.9-19.9V42.7c0-11 8.9-19.9 19.9-19.9h26.9c11 0 19.9 8.9 19.9 19.9v26.9z"
					/><circle class="st0" cx="55.9" cy="56.2" r="10.5" /></svg
				></a
			>
			<a href="https://www.linkedin.com/company/bloom-network" class="text-2xl"
				><svg
					width="31"
					height="32"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 112.2 112.2"
					style="enable-background:new 0 0 112.2 112.2"
				>
					<style>
						.st0 {
							fill: #fff;
						}
					</style>
					<path class="st0" d="M62.1 49.3v-.1s-.1 0 0 .1z" />
					<path
						class="st0"
						d="M56.1 0C25.1 0 0 25.1 0 56.1s25.1 56.1 56.1 56.1 56.1-25.1 56.1-56.1S87.1 0 56.1 0zM41.3 83.7H27.9V43.4h13.4v40.3zm-6.7-45.8c-4.6 0-7.5-3.1-7.5-7 0-4 3-7 7.6-7s7.4 3 7.5 7c0 3.9-3 7-7.6 7zm55 45.8H76.2V62.2c0-5.4-1.9-9.1-6.8-9.1-3.7 0-5.9 2.5-6.9 4.9-.4.9-.4 2.1-.4 3.3v22.5H48.7s.2-36.5 0-40.3h13.4v5.7c1.8-2.7 5-6.7 12.1-6.7 8.8 0 15.4 5.8 15.4 18.1v23.1z"
					/>
				</svg></a
			>
			<a href="https://www.youtube.com/channel/UCf-zV_9XX1GBibc2WxIFVoQ" class="text-2xl"
				><svg xmlns="http://www.w3.org/2000/svg" width="43.1" height="32" class="scale-90"
					><path
						d="M41.9 5.5c-.4-2.2-2.3-3.8-4.5-4.3C34.1.5 28 0 21.4 0S8.6.5 5.3 1.2c-2.2.5-4.1 2-4.5 4.3C.4 8 0 11.5 0 16s.4 8 .9 10.5c.4 2.2 2.3 3.8 4.5 4.3 3.5.7 9.5 1.2 16.1 1.2s12.6-.5 16.1-1.2c2.2-.5 4.1-2 4.5-4.3.4-2.5.9-6.1 1-10.5-.2-4.5-.7-8-1.2-10.5ZM16 23V9l12.2 7L16 23Z"
						style="fill:#fff"
					/></svg
				></a
			>
		</div>
	</div>
</div>

<style>
	article > ul > li > a {
		color: inherit;
		text-decoration: none;
		transition: text-decoration 0.3s;
	}

	article > ul > li > a:hover {
		text-decoration: underline;
	}
</style>
